import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 13.5 14.625"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.375 1.125h-1.687V.563a.563.563 0 0 0-1.126 0v.562H3.938V.563a.563.563 0 0 0-1.126 0v.562H1.125A1.123 1.123 0 0 0 0 2.25V13.5a1.123 1.123 0 0 0 1.125 1.125h11.25A1.123 1.123 0 0 0 13.5 13.5V2.25a1.123 1.123 0 0 0-1.125-1.125M2.812 2.25v.563a.563.563 0 0 0 1.126 0V2.25h5.624v.563a.563.563 0 0 0 1.126 0V2.25h1.687V4.5H1.125V2.25zm9.563 11.25H1.125V5.625h11.25zM7.594 8.156a.85.85 0 0 1-.521.78.85.85 0 0 1-.92-.183.846.846 0 0 1 .128-1.298.84.84 0 0 1 1.066.105.84.84 0 0 1 .247.596m3.094 0a.843.843 0 1 1-1.687-.002.843.843 0 0 1 1.687.002M4.5 10.969a.842.842 0 0 1-1.671.164.851.851 0 0 1 .358-.866.84.84 0 0 1 1.066.105.85.85 0 0 1 .247.597m3.094 0a.85.85 0 0 1-.142.469.85.85 0 0 1-.867.358.842.842 0 0 1 .165-1.671.846.846 0 0 1 .844.844m3.094 0a.843.843 0 1 1-1.687-.002.843.843 0 0 1 1.687.002"
    }, null, -1)
  ])))
}
export default { render: render }